"use strict";
import fjs from "functional.js";
const checkInit = fjs.curry((modelType, value) => {
  if (value) {
    return value;
  } else {
    if (modelType) {
      throw "";
    } else {
      throw "Error: init did not return a value.\nPossible causes:\n1) You are missing a return statement";
    }
  }
});
const checkUpdate = fjs.curry((modelType, value) => {
  if (value) {
    return value;
  } else {
    const location = modelType ? modelType.name + "." : "";
    throw "Error: " + location + "update did not return a value.\nPossible causes:\n1) You are missing a return statement\n2) You forgot to add an action to the switch statement\n3) One of your action definitions has the same string as another";
  }
});
const check = (checkReturnValues, update) => {
  if (!update) {
    return update;
  } else if (update.length == 0) {
    return () => checkReturnValues(update());
  } else if (update.length == 1) {
    return (a) => checkReturnValues(update(a));
  } else if (update.length == 2) {
    return (a, b) => checkReturnValues(update(a, b));
  } else if (update.length == 3) {
    return (a, b, c) => checkReturnValues(update(a, b, c));
  } else if (update.length == 4) {
    return (a, b, c, d) => checkReturnValues(update(a, b, c, d));
  } else if (update.length == 5) {
    return (a, b, c, d, e) => checkReturnValues(update(a, b, c, d, e));
  } else if (update.length == 6) {
    return (a, b, c, d, e, f) => checkReturnValues(update(a, b, c, d, e, f));
  } else if (update.length == 7) {
    return (a, b, c, d, e, f, g) => checkReturnValues(update(a, b, c, d, e, f, g));
  } else {
    return update;
  }
};
export default (...params) => {
  if (params.length === 4) {
    const [modelType, init, update, view] = params;
    const component = (...props) => view(...props);
    component.init = check(checkInit(modelType), init);
    component.update = fjs.curry(check(checkUpdate(modelType), update));
    component.view = view;
    _.extend(component, modelType.actions);
    return component;
  } else {
    const [init, update, view] = params;
    const component = (...props) => view(...props);
    component.init = check(checkInit(null), init);
    component.update = fjs.curry(check(checkUpdate(null), update));
    component.view = view;
    return component;
  }
};
